import {
  FETCH_PAYMENTS_SUCCESS,
  FETCH_PAYMENTS_FAILED,
  CLEAR_PAYMENTS,
} from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  results: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENTS_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        results: action.results,
      };
    case FETCH_PAYMENTS_FAILED:
      return { ...state, status: 'error', error: action.error };
    case CLEAR_PAYMENTS:
      return { ...initialState, status: 'clear' };
    default:
      return state;
  }
};
